module.exports = __webpack_public_path__ + "static/media/video-placeholder.320241a4.gif";